<template>
  <div>
    
    <Row style="width: 100%;margin-top:110px">
      <Col span="24" class="backImg">
            <img :src="img" width="100%" style="vertical-align: bottom;">
      </Col>
    </Row>
   
    <Row style="width: 100%;">
      <Col span="6" >
          <h4 class="imgCss">热文排行榜</h4>
          
            <Row v-for="(item,i) in hotPage.list" :key="i" style="color: #616060;padding: 30px 0;overflow: hidden;height: auto;">
                  <Col span="9" style="color: #616060;text-align:left;left:110px;font-size: 15px;">
                    <router-link  style="color: #616060;"
                                  :to="{path:'/newsDataDetails',
                                      query:{info:item}}">
                      {{ item.articleTitle }}</router-link>
                  </Col>
                  <!--<li class="iconfont icon-jiantou">&nbsp;&nbsp;&nbsp;&nbsp;</li>-->
              </Row>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
      </Col>
      
      </br>  <Col span="18" style="">
        <Tabs v-model="activeTab"  style="margin:0;height:680px;font-size: 16px;" type="line" @on-click="tabCli">
        <TabPane label="车界热文" name="car">
             <Row v-for="(item,i) in carPage.list" :key="i" style="color: #616060;border-bottom: #d1d1d1 solid 1px;padding: 10px 0;overflow: hidden;height: auto;width: 1350px;
    margin-left: 20px;">
                  <Col span="8" style="color: #616060;text-align:left;font-size: 15px;">
                      <router-link  style="color: #616060;"
                                  :to="{path:'/newsDataDetails',
                                      query:{info:item}}">
                      {{ item.articleTitle }}</router-link>
                  </Col>
                  <Col span="16" style="text-align: right;right:20px;"><li class="iconfont icon-ai-eye">&nbsp;&nbsp;{{ item.views }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.releaseTime }}</li></Col>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Row> 

              
        </TabPane>
        <TabPane label="天然气资讯" name="gas" >
               <Row v-for="(item,i) in gasPage.list" :key="i" style="color: rgb(97, 96, 96);border-bottom: #d1d1d1 solid 1px;padding: 10px 0;overflow: hidden;height: auto;width: 1350px;
    margin-left: 20px;">
                  <Col span="8" style="color: #616060;text-align:left;font-size: 15px;">
                      <router-link  style="color: #616060;"
                                  :to="{path:'/newsDataDetails',query:{info:item}}">
                      {{ item.articleTitle }}</router-link>
                  </Col>
                  <Col span="16" style="text-align: right;right:20px;"><li class="iconfont icon-ai-eye">&nbsp;&nbsp;{{ item.views }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.releaseTime }}</li></Col>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Row>  
          </TabPane>
        <!--
        <TabPane label="泽达报道" name="zedata" >
            <Row v-for="(item,i) in zedataPage.list" :key="i" style="color: rgb(97, 96, 96);border-bottom: #d1d1d1 solid 1px;padding: 10px 0;overflow: hidden;height: auto;width: 1350px;
    margin-left: 20px;">
                  <Col span="8" style="text-align:left;font-size: 15px;">
                      <router-link  style="color: #616060;"
                                  :to="{path:'/newsDataDetails',query:{info:item}}">
                      {{ item.articleTitle }}</router-link>
                      
                  </Col>
                  <Col span="16" style="text-align: right;right:20px;"><li class="iconfont icon-ai-eye">&nbsp;&nbsp;{{ item.views }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.releaseTime }}</li></Col>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Row> 
               
          </TabPane>-->
        </Tabs>
      </Col>
    </Row>
    
         <!-- 统一分页组件，根据当前标签显示对应数据 -->
    <Row :gutter="16">
      <Col span="24" style="margin-bottom: 60px;">
        <Page v-if="activeTab === 'car'" 
              :total="carPage.total" 
              :current="carPage.pageNum" 
              :page-size="carPage.pageSize"  
              @on-change="changepage" 
              show-total />
        <Page v-else-if="activeTab === 'gas'" 
              :total ="gasPage.total" 
              :current="gasPage.pageNum" 
              :page-size="gasPage.pageSize"  
              @on-change="changepage" 
              show-total />
        <Page v-else-if="activeTab === 'zedata'" 
              :total="zedataPage.total"
              :current="zedataPage.pageNum"
              :page-size="zedataPage.pageSize"
              @on-change="changepage"
              show-total />
      </Col>
    </Row>
    
  </div>
 
</template>
<script>

export default {
  data() {
    return {
      activeTab: 'car',  // 当前激活的标签
      info:23923,
      bid:115486,
      money:16745305.75,
      hotPage:{
        pageNum: 1,
        pageSize: 10,
        list: []
      },
      hotShow:false,
      hotNews:[],
      carPage: {
        total: 0,
        pageNum: 1,
        pageSize: 9,
        list: []
      },
      gasPage: {
        total: 0,
        pageNum: 1,
        pageSize: 9,
        list: []
      },
      zedataPage: {
        total: 0,
        pageNum: 1,
        pageSize: 9,
        list: []  
      },
       // 栏目配置映射
      categoryMap: {
        'hot': { id: 36, pageKey: 'hotPage' },
        'car': { id: 33, pageKey: 'carPage' },
        'gas': { id: 34, pageKey: 'gasPage' },
        'zedata': { id: 35, pageKey: 'zedataPage' }
      },
      carouselImg:[
        {src: "../../../../static/15.jpg",href: "www.baidu.com"},
        {src: "../../../../static/220.jpg",href: "www.baidu.com"},
        {src: "../../../../static/221.jpg",href: "www.baidu.com"},
        {src: "../../../../static/22.jpg",href: "www.baidu.com"}
      ],
      img: "../../../../static/officeImg/mediaInformation/banner.webp",
      img2:"../../../../static/officeImg/index/areaGas.png",
      img3:"../../../../static/officeImg/index/areacar.png",
      img4:"../../../../static/officeImg/index/areaSound.png",
      // img3: "../../../static/1.jpg",
      // img11: "../../../static/17.jpg",
      // img12: "../../../static/18.jpg"
    };
  },
   filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm");
        }
  },
  mounted() {
    
    // //千位分割符
    //  this.money= this.toThousands(this.money,2);
  },
  created(){
    this.loadData();
  },
  methods: {
    loadData: function() {
      // 加载所有栏目数据（或只加载第一个）
      this.fetchHotNews('hot',1);
      this.fetchNews('car', 1);
      this.fetchNews('gas', 1);
      this.fetchNews('zedata', 1);
    },

    tabCli(name){
       this.activeTab = name;
      // 如果该栏目数据为空，自动加载第一页
      const pageData = this[this.categoryMap[name].pageKey];
      if (pageData.list.length === 0) {
        this.fetchNews(name, 1);
      }
    },

    // 统一的分页切换方法
    changepage(pageNum) {
      this.fetchNews(this.activeTab, pageNum);
    },
    fetchHotNews(tabName, pageNum) {
      const config = this.categoryMap[tabName];
      const categoryId = config.id;
      const pageKey = config.pageKey;
      const pageSize = this[pageKey].pageSize;
      protocol.param_allNews.data = {
        pageSize: pageSize,
        pageNum: pageNum,
        categoryId: categoryId
      };
      http.get(protocol.param_allNews).then((res) => {
        const { code, data, total } = res.data;
        if (code === 0 && data && Array.isArray(data)) {
          // 过滤对应栏目的数据
          //const filteredData = data.filter(item => item.categoryId === categoryId);
          // 提取文章列表
          const articles = data//filteredData.flatMap(item => item.articles || []);
          // 更新分页数据（保持统一结构）
          this[pageKey] = {
            list: articles
          };
        }
      }).catch(err => {
        console.error(`获取${tabName}数据失败:`, err);
      });
    },
    fetchNews(tabName, pageNum) {
      const config = this.categoryMap[tabName];
      const categoryId = config.id;
      const pageKey = config.pageKey;
      const pageSize = this[pageKey].pageSize;
      protocol.param_allNews.data = {
        pageSize: pageSize,
        pageNum: pageNum,
        categoryId: categoryId
      };
      http.get(protocol.param_allNews).then((res) => {
        const { code, data, total } = res.data;
        if (code === 0 && data && Array.isArray(data)) {
          // 过滤对应栏目的数据
          //const filteredData = data.filter(item => item.categoryId === categoryId);
          
          // 提取文章列表
          const articles = data//filteredData.flatMap(item => item.articles || []);
          // 更新分页数据（保持统一结构）
          this[pageKey] = {
            total: total || articles.length,  // 优先使用返回的total，否则用实际长度
            pageNum: pageNum,
            pageSize: pageSize,
            list: articles
          };
        }
      }).catch(err => {
        console.error(`获取${tabName}数据失败:`, err);
      });
    }
  }
};  
</script>
<style  scoped>
@import '../../assets/iconfont/myiconfont.css';
li{

list-style: none;

}
.ivu-tabs-nav {
    padding-left: 0;
    margin: 0;
    float: left;
    list-style: none;
    box-sizing: border-box;
    position: relative;
    transition: transform .5s ease-in-out;
    font-size: 16px!important;
}
.backImg {
  background-color: white;
  width: 100%;
  font-size: 25px;
  text-align: center;
  line-height: 30px;
  color: red;
  margin-top: 0px;
  margin-left: 0px;
}
.imgCss{
  line-height: 50px; font-size: 20px; background: rgb(86, 69, 247) none repeat scroll 0% 0%; margin: 0px; color: white;height: 50px;
}
.ImgLocal{
  position:relative;
  left:180px;
  margin-top:40px;
}
.FontLocal{
  margin-top:60px;
}
.title {
    text-align: center;
    color: rgb(0, 0, 0);
    font-size: 23px;
    line-height: 40px;
    padding: 1% 0px;
}
.li2 {
  width: 50%;
  font-size: 15px;
  margin-top: 6px;
}
.numInfo {
  background: white;
  font-size: larger;
  font-family: 微软雅黑;
  height: 100px;
  padding: 20px;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.baseCard{
  background: white;
  font-family: 微软雅黑;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
  
}
.cardTitle{
  text-align: left;
  font-weight:540 !important;
  color: orange;
}

.li3 {
  width: 43%;
  font-size: 12px;
}
.icon-shuxian{
 font-size: 20px;
}
.shuxian{
  display:inline-block;
  width:4px;
  height: 22px;
  background: orange;
}
.icon-gengduo{
  color: orange;
}
.gengduo{
  font-family: 微软雅黑;
  color: rgb(120, 122, 123);
  font-size: 15px;
}
.wailian{
  font-size: 15px;
  font-weight:540;
  color:#787a7b;
}


</style>
<style >
.ivu-tabs-nav .ivu-tabs-tab {
    display: inline-block;
    height: 100%;
    padding: 8px 170px;
    margin-right: 16px;
    box-sizing: border-box;
    cursor: pointer;
    text-decoration: none;
    position: relative;
    transition: color .3s ease-in-out;
    font-size: 16px;
    font-weight: bold!important;
}
</style>



// WEBPACK FOOTER //
// src/views/newsData/newsData.vue